import { Money } from "@/components/Money";
import { monthLabel } from "@/lib/format";

export const TrendTable = ({ trend }) => {
  if (!trend) return null;
  return (
    <div className="rise-in overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-testid="trend-table">
      <div className="border-b border-slate-200 px-6 py-4">
        <h2 className="text-base font-semibold text-slate-900 md:text-lg">Monthly summary</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs font-semibold uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-6 py-2.5 text-left">Month</th>
              <th className="px-4 py-2.5 text-right">Revenue</th>
              <th className="px-4 py-2.5 text-right">COGS</th>
              <th className="px-4 py-2.5 text-right">Expenses</th>
              <th className="px-6 py-2.5 text-right">Net profit</th>
            </tr>
          </thead>
          <tbody>
            {[...trend].reverse().map((p) => (
              <tr key={p.period} className="row-hover border-t border-slate-100" data-testid={`trend-row-${p.period}`}>
                <td className="px-6 py-2 text-slate-700">{monthLabel(p.period)}</td>
                <td className="px-4 py-2 text-right"><Money value={p.revenue} /></td>
                <td className="px-4 py-2 text-right"><Money value={p.cogs} /></td>
                <td className="px-4 py-2 text-right"><Money value={p.total_expenses} /></td>
                <td className="px-6 py-2 text-right font-medium"><Money value={p.net_profit} profit data-testid={`trend-net-${p.period}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
